import { makeObservable, observable } from "mobx";
import Minigames, { MG_TYPES } from "./Minigames";
import { DataLine } from "react-sdk/haxelibs/DataManager";

class Minigame {
  /** @type {DataLine} */
  line;

  /** @type {Array<Minigame>} */
  children = null

  /**
   * Score compris entre 0 et 1. La valeur n'est pas utilisé si ce Minigame est en fait un groupement de minigames (c'est à dire s'il a des enfants)
   */
  rawScore = 0;

  threshold_1 = 0;
  threshold_2 = 0.5;
  threshold_3 = 1;

  scoresHistoric = [];

  constructor(dataLine) {
    this.line = dataLine;

    this.threshold_1 = this.line.get("threshold_1")
    // this.threshold_1 = Math.min(Math.max(this.threshold_1, 0), 1);

    this.threshold_2 = this.line.get("threshold_2")
    // this.threshold_2 = Math.min(Math.max(parseInt(this.threshold_2), 0), 1);
    this.threshold_3 = this.line.get("threshold_3")
    // this.threshold_3 = Math.min(Math.max(parseInt(this.threshold_3), 0), 1);

    makeObservable(this, {
      rawScore: observable,
      threshold_1: observable,
      threshold_2: observable,
      threshold_3: observable,
      scoresHistoric: observable
    })
  }

    /**
   * Sauvegarde le score actuel (et l'ajoute dans l'historique)
   * @param {number} score (ratio entre 0 et 1)
   */
  setRawScore(score) {
    this.rawScore = score;
    this.scoresHistoric.push(score);
  }

  /**
   * Renvoie le score du minigame :
   * - si c'est un MG avec des enfants, alors on renvoie la moyenne des scores des enfants
   * - sinon on renvoie le score (précédement indiqué via setScore)
   * @returns
   */
  getScore() {
    if (this.children && this.children.length > 0) {
      return this.children.reduce((total, mg) => total + mg.getScore(), 0) / this.children.length
    } else
      return this.score
  }

  /**
   * Calcule les étoiles en se basant sur les scores des enfants, s'il y en a, ou sur le dernier score donné (via setScore)
   */
  getStars() {
    // let score = this.getScore();
    let score = this.score

    if(this.threshold_1 < this.threshold_3) {
      if (score >= this.threshold_3)
        return 3;
      else if (score >= this.threshold_2)
        return 2;
      else if (score >= this.threshold_1)
        return 1;
      else
        return 0;
    }
    else {
      if (score <= this.threshold_3)
        return 3;
      else if (score <= this.threshold_2)
        return 2;
      else if (score <= this.threshold_1)
        return 1;
      else
        return 0;
    }




  }

  isContainer() {
    return (this.children && this.children.length > 0);
  }

  findCurrentMinigameIndex(current) {
    if (!this.isContainer) return null

    return this.children.findIndex(child => child === current);

  }

  get id() {
    return this.line.id
  }
  get description() {
    return this.line.getEvaluated("description")
  }
  get name() {
    return this.line.get("name")
  }
  get type() {
    if (!this.line.get("type")) {
      if(this.children && this.children.length > 0)
        return this.children[0].type;
      return null;
    }

    return this.line.get("type")
  }
  get score() {

    if(this.children && this.children.length > 0)
      return this.rawScore

    switch(this.type) {
      case MG_TYPES.QUIZ:
        return Math.round(this.rawScore * 10)
      case MG_TYPES.DRAGDROP:
        return Math.round(this.rawScore * 100)
      case MG_TYPES.SWIPE:
        return Math.round(this.rawScore * 100)
      case MG_TYPES.REORDER:
        return Math.round(this.rawScore * 100)
      case MG_TYPES.SOKOBAN:
        return Math.round(this.rawScore)
      case MG_TYPES.CONNECTION_LINK:
        return Math.round(this.rawScore)
      case MG_TYPES.LABYRINTH:
        return Math.round(this.rawScore)
    }
  }

  get skipScore() {
    switch(this.type) {
      case MG_TYPES.QUIZ:
        return 0
      case MG_TYPES.DRAGDROP:
        return 0
      case MG_TYPES.SWIPE:
        return 0
      case MG_TYPES.REORDER:
        return 0
      case MG_TYPES.SOKOBAN:
        return Number.MAX_SAFE_INTEGER
      case MG_TYPES.CONNECTION_LINK:
        return Number.MAX_SAFE_INTEGER
      case MG_TYPES.LABYRINTH:
        return Number.MAX_SAFE_INTEGER
    }
  }

  get ref() {
    return this.line.get("ref")
  }
  get icon() {
    return this.line.get("icon")
  }
  get parent() {
    return this.line.get("parent")
  }

  get img_url() {

    if(this.icon) return "data/images/minigames_icons/" + this.icon + ".png";

    return "data/images/minigames_icons/" + this.type + ".png";
  }

  get elementRef() {
    let ref = this.ref

    if (!ref) return null;

    if (this.type === MG_TYPES.QUIZ)
      return Minigames.qcms.get(ref);
    else if (this.type === MG_TYPES.DRAGDROP)
      return Minigames.dragdrops.get(ref);
    else if (this.type === MG_TYPES.SWIPE)
      return Minigames.swipes.get(ref);
    else if (this.type === MG_TYPES.REORDER)
      return Minigames.reordonners.get(ref);
    else
      return ref;
  }
}

export default Minigame;
